var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoCamera = function SvgVideoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.59 4.64A3 3 0 0 0 1.5 7.5v9a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-1.19l3.44 3.44c.944.945 2.56.276 2.56-1.06V6.31c0-1.336-1.616-2.005-2.56-1.06l-.46.46-3.785-.255A3 3 0 0 0 13.5 4.5h-9c-.317 0-.623.05-.91.14m0 0 12.105.815c.5.535.805 1.255.805 2.045v1.19l2.98-2.98M21 17.69l-4.5-4.5v-2.38l4.5-4.5zM15 7.5A1.5 1.5 0 0 0 13.5 6h-9A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h9a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgVideoCamera;